import Product from '../../domains/Product/Product'
import { ShopifyVariantDetails } from '../../domains/ProductPurchaseInfo'

import { getVariantDetailsByIdForProductVariants } from './NewCheckoutProductService'

class ShopifyProductService {
  private shopifyClient: any

  async getShopifyVariantDetailsByIdForProductVariants(
    product: Product,
  ): Promise<Record<number, ShopifyVariantDetails>> {
    return await getVariantDetailsByIdForProductVariants(product)
  }
}

const shopifyProductService = new ShopifyProductService()

export default shopifyProductService
